import { CobaltDivider } from '@cae/cobalt-react/components/divider';
import { DataValue } from '@shared/components/data-value/DataValue';
import { formatDateShort } from '@shared/utils/format-date/formatDate';
import * as React from 'react';

import type { ReservationDetailsSectionProps } from './ReservationDetailsSection.types';

import styles from '../InvoiceDetailPanel.module.css';

const ReservationDetailsSection = React.memo(
  ({
    reservations,
  }: Readonly<ReservationDetailsSectionProps>): React.ReactElement => {
    return (
      <section className={styles.section}>
        <h3 className={`heading-01 ${styles.sectionTitle}`}>
          Reservation details
        </h3>
        {reservations
          .filter((r): r is typeof r & { reservationNumber: string } => r.reservationNumber != null)
          .map((reservation, index) => (
          <div
            key={reservation.reservationNumber}
            data-testid="invoice-detail-reservation"
          >
            {index > 0 && (
              <CobaltDivider className={styles.divider} color="subtle" />
            )}
            <ul className={styles.fieldList}>
              <li className={styles.field}>
                <span className={`body-01 ${styles.fieldLabel}`}>
                  Reservation number
                </span>
                <span className={`body-02 ${styles.fieldValue}`}>
                  <DataValue value={reservation.reservationNumber} />
                </span>
              </li>
              <li className={styles.field}>
                <span className={`body-01 ${styles.fieldLabel}`}>
                  Crew member
                </span>
                <span className={`body-02 ${styles.fieldValue}`}>
                  <DataValue value={reservation.crewMember} />
                </span>
              </li>
              <li className={styles.field}>
                <span className={`body-01 ${styles.fieldLabel}`}>Course</span>
                <span className={`body-02 ${styles.fieldValue}`}>
                  <DataValue value={reservation.courseName} fallback="-" />
                </span>
              </li>
              <li className={styles.field}>
                <span className={`body-01 ${styles.fieldLabel}`}>Platform</span>
                <span className={`body-02 ${styles.fieldValue}`}>
                  <DataValue value={reservation.platform} />
                </span>
              </li>
              <li className={styles.field}>
                <span className={`body-01 ${styles.fieldLabel}`}>Location</span>
                <span className={`body-02 ${styles.fieldValue}`}>
                  <DataValue value={reservation.location} />
                </span>
              </li>
              <li className={styles.field}>
                <span className={`body-01 ${styles.fieldLabel}`}>
                  Training start date
                </span>
                <span className={`body-02 ${styles.fieldValue}`}>
                  <DataValue
                    value={formatDateShort(reservation.trainingStartDate)}
                  />
                </span>
              </li>
            </ul>
          </div>
        ))}
      </section>
    );
  }
);

ReservationDetailsSection.displayName = 'ReservationDetailsSection';
export { ReservationDetailsSection };
